import React,{ Component } from "react";
import { InputField } from "../../../../common/custom-form/input-filter-component";
import { TabberButton } from "../../../../common/custom-form/tabber-button.component";
import ButtonIcon from "../../../../button";
import { InputGroup, FormControl, Button } from "react-bootstrap";
import InvoiceComment from "../../../../common/report/reports/Invoice/manage-invoice/invoice-comment.component";
import { SelectField } from "../../../../common/custom-form/select-filter.component";
import ManageLayout from "../../../../common/report/details/manage-report.component";
import { OrderHistory } from "../../../order/order-summary/order-history.component";
import OrderCircuitDetails from "../../../order/manage-order/order-circuit-detail.component";
import OrderSummary from "../../../order/order-summary/order-summary.component";
import { Selected_Index } from "../../../../../constants/internal-constants";
import { DetailsDataTable } from "../../../inventory/DetailsView/details-table/details-table.component";
import   InvoiceHistory  from "../../../../common/report/reports/Invoice/manage-invoice/invoice-history.component";
export default class CatalogueDetails extends Component{
    constructor(props){
        super(props);
        this.getDataSelected=this.getDataSelected.bind(this);
        this.openCircuitView=this.openCircuitView.bind(this);
        this.state={
            selectFilter:[
                {
                    "FilterId":5,
                    "FilterName":"Account Number",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":4,
                    "FilterName":"Circuit ID",
                    "FilterType":"Textbox","Page":
                    "CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":7,
                    "FilterName":"Circuit Status",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                }
               ],
            filterSelected: "", 
            inputValue: "",
            invoiceDate: "",
            invoiceApproveDate: "",
            invoiceDueDate: "",
            billingPeriodDate: "",
            invoiceExpectedDate: "",
            rentalPeriodDate: "",
            actualInvoiceMonth: "",
            invoiceReceiptDate: "",
            beginDate: "",
            endDate: "",
            showOrderSummary: false,
            openCircuitDetails:false,
            showTable:false,
            dataTable:[
                {              
                    HeaderItem:[
                        {
                            name:"Contract Name"
                        },
                        {
                            name:"Vendor"
                        }, {
                            name:"Status"
                        }
                    ],
                    dataItem:[{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"                       
                    }, {            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    },{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    }        
                    ]
    
                }
            ],
            selectedIndex:"0", 
            dataSelected:0,
            tableSelected:false,
            listTabInfo:{
                Tab:[
                    {
                        "id":"0",
                        "label":"Details"            
                    },
                    {
                        "id":"1",
                        "label":"History"           
                    },
                    {
                        "id":"2",
                        "label":"Comments"           
                    }
                ]
            },
            dataInfo:[
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0",
                         "Order Submit Date: From: May 31, 2021 at 4:00PM TO: June 07, 2021 at 4:00 AM",
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                }
            ],
            commentData:[
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[
                         "Update-Circuit ID: 0"                         
                     ]
                },
                {
                    "name " : "Johny Deep",
                    "date " : "June 08, 2021",
                    "time" : "4:00 PM",
                     "comment" :[                         
                         "Order Circuit Required Date: From: TO: June  07, 2021 at 4:00PM"
                     ]
                }
            ],
            statusList:[
                {
                    "status":"Order Created",
                    "dateCompleted": "29/09/2022"
                },
                {
                    "status":"Order Submitted"                
                },
                {
                    "status":"Order Receipt Confirmed"                    
                },
                {
                    "status":"Circuit Installed"                    
                }

            ]

        }
    }

    getDataSelected(data) {
        this.setState({selectedIndex:data})
       
    }

    openLineItem(data) {
        this.setState({tableSelected:data})
    }

    openCircuitView(value){
       
        this.setState({openCircuitDetails:value})   
        this.setState({showOrderSummary:false})  
        this.setState({selectedIndex:"0"})   
    }
    ShowTable() {
        this.setState({showTable:!this.showTable})
    }
     
    render(){   
        const {selectFilter,dataInfo,startDate,dataTable,listTabInfo,tableSelected,selectedIndex}=this.state;           
        return(
            <>
            {
                !this.state.showOrderSummary ?
                this.state.openCircuitDetails ? 
                <OrderCircuitDetails closeForm={this.openCircuitView}/>
                :
    
                <ManageLayout customClassName="manage-order-table finance-detail-table" buttonLabel="Back"  haveStatusLabel={false} onGetSelected={this.getDataSelected.bind(this)} statusList={this.state.statusList} closeForm={this.props.closeForm} listData={listTabInfo.Tab} haveHeaderButton={false}>
    
                        {
                            selectedIndex===Selected_Index.i_Zero &&
                                <>
                                    <div className="manage-order-container">
                                        <div className="manage-order-detail">
                                            <SelectField label="VENDOR"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>
                                            <SelectField label="ACCOUNT NUMBER"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                
                                            <InputField label="SUB ACCOUNT NUMBER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                            <InputField label="PRICE PLAN" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                            <SelectField label="STATUS"  options={selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                
                                            <InputField label="MRC" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                            <InputField label="DESCRIPTION" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                      </div>
                                    </div>
                                    <h1>Plan Component Details</h1>
                                    <div className="manage-order-container">                                       
                                        <div className="details-4-col-container">
                                            <InputField label="Plan Component" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                                            <InputField label="COST" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                                            <InputField label="Description" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})} />
                                            <div className="add-button-container ">
                                                <Button>Cancel</Button>
                                                <Button className="add-btn" onClick={this.ShowTable.bind(this)}>Add</Button>
                                            </div>                
                                        </div>
                                        {
                                            this.state.showTable && 
                                            <DetailsDataTable datatable={this.state.dataTable} haveEditBtn={true} haveDeleteBtn={true} />       
                                        } 
                                    </div>                                         
                                    <div className="save-btn-container">
                                        <Button className="save-button"> Save Changes </Button>                                   
                                    </div>                                
                                </>
                        }
    
                        {
                            selectedIndex===Selected_Index.i_One &&
                            < InvoiceHistory dataInfo={this.state.dataInfo} noMessage="No History Available"/>
                            
                        }
    
                        {
                            selectedIndex===Selected_Index.i_Two &&
                            <InvoiceComment dataInfo={this.state.commentData} noMessage="No Comment Available"/>
                        }
    
                    </ManageLayout>
                :
                <OrderSummary closeForm={this.openCircuitView}/>
            }
           
            </>
        )
    }
}